
import Vue, { PropType } from 'vue'

import JFileInput from '@/ui/controls/JFileInput.vue'

export default Vue.extend({
  components: {
    JFileInput,
  },
  data: () => ({
    capture: 'environment' as string | null, // 'user' or 'environment' for camera input
  }),
  props: {
    value: {
      type: [Object, Array] as PropType<File | File[]>,
      default: () => [],
    },
    multiple: Boolean,
  },
})
